import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  detailAddressReducer,
  DetailAddressState,
} from './detail-address.reducer';
import {
  suggestedAddressesReducer,
  SuggestedAddressesState,
} from './suggested-addresses.reducer';

export interface PhysicalAddressState {
  autocomplete: SuggestedAddressesState;
  metadata: DetailAddressState;
}

export const reducers: ActionReducerMap<PhysicalAddressState> = {
  // @ts-ignore
  metadata: detailAddressReducer,
  // @ts-ignore
  autocomplete: suggestedAddressesReducer,
};

export const getPhysicalAddressState =
  createFeatureSelector<PhysicalAddressState>('physicalAddress');
